/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import IconFont from 'Components/common/iconFont';
import {getElementPos} from 'Utils';
import timeFormat from 'Utils/timeFormat';

import './index.less';

class CompleteAudio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reStart: props.reStart, // 重新播放
      isPlaying: false, // 是否正在播放
      currentTime: '00:00', // 当前时长
      duration: '00:00', // 总时长
      silence: true, // 静音状态
    };
  }

  componentDidMount() {
    const {audio} = this;

    audio.addEventListener('canplaythrough', this.onCanPlayThrough, false);
    audio.addEventListener('error', this.onError, false);
    audio.addEventListener('timeupdate', this.onTimeUpdate, false);
    audio.addEventListener('ended', this.onEnded, false);
    this.changeProgress('sound');
    this.changeProgress('time');
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.reStart !== prevState.reStart) {
      if (nextProps.reStart) {
        return {
          reStart: nextProps.reStart,
          isPlaying: false,
          currentTime: '00:00',
          duration: '00:00',
        };
      }

      return {
        reStart: nextProps.reStart,
        isPlaying: true,
      };
    }
    return null;
  }

  componentDidUpdate() {
    const {
      audio,
      progressDot,
      state: {reStart},
    } = this;

    if (reStart) {
      audio.pause();
      audio.currentTime = 0;
      progressDot.style.left = '-6px';
    }
  }

  componentWillUnmount() {
    const {audio} = this;

    audio.removeEventListener('canplaythrough', this.onCanPlayThrough);
    audio.removeEventListener('error', this.onError);
    audio.removeEventListener('timeupdate', this.onTimeUpdate);
    audio.removeEventListener('ended', this.onEnded);
    this.setState = () => {};
  }

  onCanPlayThrough = () => {
    const {
      audio,
      state: {reStart},
      props: {getAudioDuration},
    } = this;

    if (!audio) return;

    const {duration} = audio;
    const time = timeFormat(duration);
    const transferCallDuration = timeFormat(duration, 'hour'); // 左侧-通话信息-通话时长

    if (!reStart) {
      this.setState(
        {
          duration: time,
          isPlaying: true,
        },
        () => {
          audio.play();
        },
      );

      getAudioDuration({
        transferCallDuration,
        callDuration: duration,
      });
    }
  };

  onError = () => {
    this.setState({
      isPlaying: false,
      currentTime: '00:00',
      duration: '00:00',
    });
    this.props.getAudioDuration({transferCallDuration:'0:00:00',callDuration:0});
  };

  onTimeUpdate = () => {
    const {audio, progressDot, progressBar} = this;

    if (audio) {
      const currentTime = timeFormat(audio.currentTime) || '00:00';
      const sWidth = !audio.duration
        ? 0
        : (audio.currentTime / audio.duration) * progressBar.clientWidth;

      progressDot.style.left = `${sWidth - 6}px`;
      this.setState({currentTime});
    }
  };

  onEnded = () => {
    const {progressDot} = this;

    this.setState({
      isPlaying: false,
      currentTime: '00:00',
    });
    progressDot.style.left = '-6px';
  };

  play() {
    const {
      audio,
      state: {isPlaying},
    } = this;

    this.setState(
      {
        isPlaying: !isPlaying,
      },
      () => {
        const {isPlaying: currentIsPlaying} = this.state;

        if (currentIsPlaying) {
          audio.play();
        } else {
          audio.pause();
        }
      },
    );
  }

  // 静音
  silence() {
    const {
      audio,
      soundDot,
      state: {silence},
    } = this;

    this.setState({silence: !silence});
    if (silence) {
      audio.volume = 0;
      soundDot.style.left = `${-6}px`;
    } else {
      audio.volume = 1;
      soundDot.style.left = `${94}px`;
    }
  }

  mouseMove(ev, flag) {
    const {
      audio,
      soundBar,
      soundDot,
      progressBar,
      progressDot,
      state: {duration},
    } = this;
    let el;
    let target;
    let attr;

    if (flag === 'sound') {
      el = soundBar;
      target = soundDot;
      attr = 'volume';
    } else if (flag === 'time') {
      el = progressBar;
      target = progressDot;
      attr = 'currentTime';
    }

    const progressLeft = getElementPos(el).x;
    const eLeft = ev.clientX;
    const sWidth = el.clientWidth;

    if (eLeft - progressLeft >= 0 && eLeft - progressLeft <= sWidth) {
      target.style.left = `${eLeft - progressLeft - 6}px`;
    } else if (eLeft - progressLeft < 0) {
      target.style.left = '-6px';
    } else if (eLeft - progressLeft > el.clientWidth) {
      target.style.left = `${sWidth - 6}px`;
    }

    // 区分进度和音量
    if (flag === 'sound') {
      if (eLeft - progressLeft <= 0) {
        audio[attr] = 0;
        this.setState({silence: false});
      } else if (eLeft - progressLeft < 100 && eLeft - progressLeft > 0) {
        audio[attr] = (eLeft - progressLeft) / sWidth;
        this.setState({silence: true});
      } else {
        audio[attr] = 1;
      }
    }

    if (flag === 'time') {
      let currentTime;

      if (eLeft - progressLeft <= 0) {
        audio.currentTime = 0;
        currentTime = '00:00';
      } else if (eLeft - progressLeft <= 100 && eLeft - progressLeft > 0) {
        const time = ((eLeft - progressLeft) * audio.duration) / sWidth;

        audio.currentTime = time;
        currentTime = timeFormat(time);
      } else {
        audio.currentTime = audio.duration;
        currentTime = duration;
      }

      this.setState({currentTime, isPlaying: true});
    }
  }

  changeProgress(type) {
    const {soundDot, progressDot} = this;
    let target;

    if (type === 'sound') {
      target = soundDot;
    } else if (type === 'time') {
      target = progressDot;
    }

    target.onmousedown = () => {
      document.onmousemove = ev => {
        this.mouseMove(ev, type);
      };
      document.onmouseup = ev => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.mouseMove(ev, type);
      };
      return false;
    };
  }

  render() {
    const {source, id,downLoadBol} = this.props;
    const {isPlaying, currentTime, duration, silence} = this.state;

    return (
      <div className="complete-audio">
        {/* 音频播放器 */}
        <audio
          src={source}
          controls="controls"
          ref={c => {
            this.audio = c;
          }}>
          Your browser does not support the audio element.
        </audio>

        <div className="complete-audio-play">
          {/* 播放按钮 */}
          <div
            className="play-button"
            onClick={() => {
              this.play();
            }}>
            <IconFont
              type={isPlaying ? 'icon-robotpause1' : 'icon-robottriangle-right'}
            />
          </div>

          {/* 时长 */}
          <span className="play-time">
            {currentTime}
            /
            {duration}
          </span>

          {/* 进度条 */}
          <div
            className="progress"
            ref={c => {
              this.progressBar = c;
            }}>
            <div
              className="progress-dot"
              ref={c => {
                this.progressDot = c;
              }}
            />
          </div>

          {/* 音量按钮 */}
          <div
            className="sound-button"
            onClick={() => {
              this.silence();
            }}>
            <IconFont
              type={silence ? 'icon-robotvoice-fill' : 'icon-robotnotice-no'}
            />
          </div>

          {/* 音量调节 */}
          <div
            className="sound"
            ref={c => {
              this.soundBar = c;
            }}>
            <div
              className="sound-dot"
              ref={c => {
                this.soundDot = c;
              }}
            />
          </div>

          {/* 下载 */}
            <span
              className="download"
              // href={`/robot/taskinfo/voice/download/${id}`}
              //href={source}
              // eslint-disable-next-line react/jsx-no-target-blank
             // target="_blank"
              rel="noreferrer"
              onClick={()=>{
                window.location.href=source;
              }}
              >
              <IconFont type="icon-robotdownload" />
            </span>
        </div>
      </div>
    );
  }
}

export default CompleteAudio;
